import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';

export default function CanvasError({ className }: { className?: string }) {
  return (
    <div
      className={`bg-gray-30 dark:bg-gray-60 flex h-full w-full flex-col items-center justify-center gap-4 ${className}`}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="32px"
        width="32px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
        <path d="m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"></path>
      </svg>
      <Text variant="studio/body/medium/md">Something went wrong</Text>
      <Button variant="secondary" onClick={() => window.location.reload()}>
        Refresh page
      </Button>
    </div>
  );
}
